import styled from 'styled-components';
import { Button, Typography } from '@libs/components';
import { LoyaltyGift } from 'src/assets';

export const Container = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius.highM};
  background: linear-gradient(102deg, #5e47d0 8.76%, #65aafe 91.45%);
  height: 20rem;
  width: 100%;
`;
export const InsideContainer = styled.div`
  padding: 1.4rem 1.4rem 1.9rem;
  width: 100%;
  height: 100%;
  background-image: url(${LoyaltyGift});
  background-repeat: no-repeat;
  background-position-x: 95%;
  background-position-y: bottom;
  background-size: 14rem;
  display: flex;
  flex-direction: column;
`;
export const Title = styled(Typography)`
  margin-bottom: 0.8rem;
`;
export const CustomButton = styled(Button)`
  margin-top: auto;
  width: 12.7rem;
`;
